module.exports = __webpack_public_path__ + "static/media/dashboard.01982fd5.svg";